import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import React from 'react';
import VBox from 'components/common/VBox';

export default function ExerciseDialogInsulinTable(props) {
  const {
    data,
    ...rest
  } = props;

  const {
    bldsugr_graph_list = [],
    // bld_sugr_time,
    // bld_sugr_value,
    step_cnt_graph_list = [],
    // active_time,
    // step_cnt,
    daily_step_cnt,
    daily_step_time,
    postprand2h_step_cnt,
    postprand2h_step_time,
    daily_burn_cal,
    postprand2h_burn_cal,
    max_bldsugr_val,
    max_bldsugr_time,
    max_bldsugr_tmzone_cd,
    min_bldsugr_val,
    min_bldsugr_time,
    min_bldsugr_tmzone_cd,
    max_bldsugr_rise_w,
    avg_bldsugr,
    postprand2h_bldsugr_val,
    total_abnormal_cnt,
    total_high_cnt,
    total_low_cnt,
    avg_intaken_cal,
    total_intaken_cal,
    carbo_rate,
    protein_rate,
    fat_rate,
    total_insulin_amt,
    total_bolus_amt,
    total_giju_amt,
    bolus_inject_list = [],
    // bolus_inject_time,
    // bolus_inject_amt,
  } = data;

  const bs = React.useMemo(() => {
    let count = -1;
    const list = [];
    bolus_inject_list.forEach((c, index) => {
      const time = c.bolus_inject_time.split('');
      time.splice(2, 0, ':');
      if (index % 4 === 0) {
        ++count;
        list.push([]);
      }
      const ls = list[count];
      ls.push(T('{0} ({1} U)', time.join(''), c.bolus_inject_amt));
    }, []);
    return list;
  }, [bolus_inject_list]);

  return (
    <table>
      <tbody>
        <tr>
          <th>
            <div>
              {T('총 투여량')}
            </div>
          </th>
          <td>
            <div>
              {T('{0} U (볼루스 {1} U, 기저 {2} U)', total_insulin_amt, total_bolus_amt, total_giju_amt)}
            </div>
          </td>
        </tr>
        <tr>
          <th>
            <div>
              {T('볼루스 투여기록')}
            </div>
          </th>
          <td>
            <VBox>
              {bs.map((ls, index) => (
                <div key={index}>
                  {ls.join(', ')}
                </div>
              ))}
            </VBox>
          </td>
        </tr>
      </tbody>
    </table>
  );
}
